import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { telehealthActions } from '../../../_actions/telehealth.actions';
import { telehealthConstants } from '../../../_constants/telehealth.constants';
import { NotificationAlertIcon } from '@axshealth/design-library'
import { Button, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap'

import moment from 'moment';
import DataTable from 'react-data-table-component';
import queryString from 'query-string';
import SearchFilters from './SearchFilters';
import TelehealthsEmpty from './Empty';
import DetailsComponent from './Details';

import SentActions from './Components/SentActions';
import ReadyActions from './Components/ReadyActions';
import CanceledActions from './Components/CanceledActions';
import ScheduledActions from './Components/ScheduledActions';
import CompletedActions from './Components/CompletedActions';
import RoomCard from './Components/RoomCard';

import { AbilityContext, Can } from '../../../_contexts/AbilitiesContext'

class List extends Component {

  static contextType = AbilityContext

  constructor(props) {
    super(props);

    this.loadData = this.loadData.bind(this);
  }

  componentDidMount() {
    const { currentUser } = this.props;

    if (currentUser.UserType.Name === 'Licensed') {
      const providerId = currentUser.Doctor.DoctorId;
      this.props.history.push(`/telehealth?professional=${providerId}&time=${Date.now()}`)
    } else {
      this.loadData();

      this.loadRooms();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.search !== this.props.location.search) {
      this.loadData();

      this.loadRooms();
    }
  }

  componentWillUnmount() {
    this.props.dispatch({ type: telehealthConstants.TH_CLEAR_STATE })
  }

  loadData() {
    const searchParams = this.searchParams();

    this.props.dispatch(telehealthActions.searchTelehealths(searchParams));
  }

  loadRooms() {
    const searchParams = this.searchParams();

    this.props.dispatch(telehealthActions.searchRooms(searchParams));
  }

  searchParams() {
    const queryParams = queryString.parse(this.props.location.search);
    const showDateRange = ("telehealthStartDate" in queryParams) ? true : false;

    return {
      page: queryParams.page || 1,
      firstName: queryParams.firstName || '',
      lastName: queryParams.lastName || '',
      dateOfBirth: queryParams.dateOfBirth || '',
      appointmentDate: !showDateRange ? queryParams.appointmentDate || '' : '',
      telehealthStartDate: showDateRange ? queryParams.telehealthStartDate || '' : '',
      telehealthEndDate: showDateRange ? queryParams.telehealthEndDate || '' : '',
      groupId: queryParams.location ? parseInt(queryParams.location) : '',
      providerId: queryParams.professional ? parseInt(queryParams.professional) : '',
      status: queryParams.status || '',
      preVisitQuestionId: queryParams.preVisitQuestionId ? parseInt(queryParams.preVisitQuestionId) : '',
    }
  }

  hasRoomAccess() {
    return this.props.currentUser.UserType.Name === 'Licensed' || this.context.can('room-access', 'telehealth')
  }

  render() {
    const columns = [
      {
        name: '',
        sort: false,
        width: '10px',
        cell: row => {
          if (row.isUnread && row.status === 'READY') {
            return <div style={{ marginBottom: '1px' }}>
              <NotificationAlertIcon />
            </div>
          }
        }
      },
      {
        name: '',
        sort: false,
        width: '50px',
        cell: row => {
          if (row.telemedicineType === 'video') {
            return <OverlayTrigger placement="top" overlay={<Tooltip>Real-Time Video</Tooltip>}>
              <span className='badge badge-pill p-1 badge-dark'> <i className="fas fa-video fa-sm"></i></span>
            </OverlayTrigger>

          }
          return <OverlayTrigger placement="top" overlay={<Tooltip>Asynchronous</Tooltip>}>
            <span className='badge badge-pill p-1 badge-dark'><i className="fas fa-comments  fa-sm"></i></span>
          </OverlayTrigger>
        }
      },
      {
        name: 'Status',
        sort: false,
        cell: row => {
          if (row.status === 'READY' || row.status === 'HOLD') {
            return <Link className="btn btn-success" to={`/telehealth/${row.id}`}>Join</Link>
          }

          return <span className='badge badge-info text-uppercase'>{row.status}</span>
        }
      },
      {
        name: 'Patient Name',
        sort: false,
        cell: row => {
          if (row.userProfile) {
            return `${row.userProfile.firstName} ${row.userProfile.lastName}`
          } else {
            return `${row.patientFirstName} ${row.patientLastName}`
          }
        }
      },
      {
        name: 'Telehealth Date',
        sort: false,
        cell: row => {
          return <>
            {moment.tz(row.appointmentDate.date, row.appointmentDate.timezone).local().format('l LT')}
          </>
        }
      },
      {
        name: 'Provider',
        sort: false,
        cell: row => {
          return `${row.doctor.firstName} ${row.doctor.lastName}`
        }
      },
      {
        name: 'Location',
        sort: false,
        cell: row => {
          return row.providerGroup.name
        }
      },
      {
        name: 'Pre Visit Questions',
        sort: false,
        cell: telehealth => {
          return telehealth.questionnaire.title
        }
      },
      {
        button: true,
        width: '150px',
        sort: false,
        style: { justifyContent: "left" },
        cell: (telehealth) => {
          if (telehealth.status === 'SCHEDULED') {
            return <ScheduledActions telehealth={telehealth} />
          }
          if (telehealth.status === 'SENT') {
            return <SentActions loadData={this.loadData} telehealth={telehealth} />
          }
          if (telehealth.status === 'HOLD' || telehealth.status === 'READY') {
            return <ReadyActions telehealth={telehealth} />
          }
          if (telehealth.status === 'COMPLETED') {
            return <CompletedActions telehealth={telehealth} />
          }
          if (telehealth.status === 'CANCELED') {
            return <CanceledActions telehealth={telehealth} />
          }
        }
      }
    ];

    const { isSearching, collection, total, location } = this.props;

    const urlParams = this.searchParams();

    return (
      <div className="row">
        <div className="col-lg-10 offset-lg-2">
          <div className="row">
            <div className="col-lg-6">
              <h1 className="h2"><i className="fas fa-laptop-medical" aria-hidden="true"></i> Telehealth</h1>
            </div>

            <Can I="schedule" a="telehealth">
              <div className="col-lg-6 text-right">
                <Button
                  as={Link}
                  to="/telehealth/schedule"
                  variant="primary"
                  className="px-4">Schedule Telehealth
                </Button>
              </div>
            </Can>

          </div>
        </div>

        <div className="col-lg-12 mt-3">
          <div className="row">
            <div className="col-lg-2">
              <SearchFilters location={this.props.location} handleSearch={(params) => {
                const { firstName, lastName, dateOfBirth, appointmentDate, telehealthStartDate, telehealthEndDate, preVisitQuestionId, location, professional, status, showDateRange } = params;

                const startDate = telehealthStartDate ? moment(telehealthStartDate).format("L") : '';
                const endDate = telehealthEndDate ? moment(telehealthEndDate).format("L") : '';

                this.props.history.replace(`/telehealth?firstName=${firstName}&lastName=${lastName}&dateOfBirth=${dateOfBirth}${showDateRange ? `&telehealthStartDate=${startDate}&telehealthEndDate=${endDate}` : `&appointmentDate=${appointmentDate}`}&location=${location}&professional=${professional}&preVisitQuestionId=${preVisitQuestionId}&status=${status}`)
              }} />
            </div>
            <div className="col-lg-10">
              { isSearching && <Spinner animation="border" role="status" /> }

              { !isSearching && !location.search && total === 0 &&
                <TelehealthsEmpty />
              }

              { this.hasRoomAccess() && this.props.rooms.length > 0 &&
                <div className="row">
                  <p className='col-12'><strong>Telehealth Rooms:</strong></p>
                  { this.props.rooms.map(room => {
                    return <div key={room.id} className="col-4">
                      <RoomCard room={room} />
                    </div>
                  })}
                </div>
              }

              { ((!isSearching && location.search) || (!isSearching && !location.search && total > 0)) &&
              <DataTable
                overflowY
                columns={columns}
                data={collection}
                progressPending={isSearching}
                onChangePage={page => {
                  const queryParams = queryString.parse(this.props.location.search);
                  const showDateRange = ("telehealthStartDate" in queryParams) ? true : false;

                  const firstName = queryParams.firstName || '';
                  const lastName = queryParams.lastName || '';
                  const dateOfBirth = queryParams.dateOfBirth || '';
                  const appointmentDate = queryParams.appointmentDate || '';
                  const telehealthStartDate = queryParams.telehealthStartDate || '';
                  const telehealthEndDate = queryParams.telehealthEndDate || '';
                  const location = queryParams.location ? parseInt(queryParams.location) : '';
                  const professional = queryParams.professional ? parseInt(queryParams.professional) : '';
                  const preVisitQuestionId = queryParams.preVisitQuestionId ? parseInt(queryParams.preVisitQuestionId) : '';
                  const status = queryParams.status || '';

                  this.props.history.replace(`/telehealth?page=${page}&firstName=${firstName}&lastName=${lastName}&dateOfBirth=${dateOfBirth}${showDateRange ? `&telehealthStartDate=${telehealthStartDate}&telehealthEndDate=${telehealthEndDate}` : `&appointmentDate=${appointmentDate}`}&location=${location}&professional=${professional}&preVisitQuestionId=${preVisitQuestionId}&status=${status}`)
                }}
                noHeader={true}
                striped={true}
                pagination={true}
                paginationServer={true}
                paginationTotalRows={total}
                paginationRowsPerPageOptions={[15]}
                paginationPerPage={15}
                paginationDefaultPage={parseInt(urlParams.page)}
                expandableRows
                expandOnRowClicked
                expandableRowsComponent={<DetailsComponent />}
                noDataComponent={<div className="p-4">We could not find any results based on your search criteria</div>}
                customStyles={{ cells: { style: { fontSize: '14px' }, }, }}
              />
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    rooms: state.telehealth.rooms,
    collection: state.telehealth.collection.collection ? state.telehealth.collection.collection.data : [],
    total:  state.telehealth.collection.collection ? state.telehealth.collection.total : 0,
    currentUser: state.user.currentUser,
    isSearching: state.telehealth.isSearching,
  };
}

export default connect(mapStateToProps)(List);